module.exports = __webpack_public_path__ + "static/media/cr_active.a4c6dbb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/cr_active.svg
// module id = 1085
// module chunks = 36